import * as React from 'react';
import Box from '@mui/joy/Box';
import Breadcrumbs from '@mui/joy/Breadcrumbs';
import Link from '@mui/joy/Link';
import Typography from '@mui/joy/Typography';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import LeafletDownloads from './leaflets/LeafletDownloads';

export default function LeafletRequests() {
  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Breadcrumbs
          size="sm"
          aria-label="breadcrumbs"
          separator={<ChevronRightRoundedIcon />}
          sx={{ pl: 0 }}
        >
          <Link underline="none" color="neutral" href="/dashboard" aria-label="Home">
            <HomeRoundedIcon />
          </Link>
          <Link underline="hover" color="neutral" href="/dashboard" fontSize={12} fontWeight={500}>
            Dashboard
          </Link>
          <Typography color="primary" fontWeight={500} fontSize={12}>
            Leaflet Downloads
          </Typography>
        </Breadcrumbs>
      </Box>

      <Box sx={{ display: 'flex', mb: 1, gap: 1, flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'start', sm: 'center' }, flexWrap: 'wrap', justifyContent: 'space-between' }}>
        <Typography level="h2" component="h1">
          Leaflet Downloads
        </Typography>
      </Box>

      <Typography level="body-sm" sx={{ mb: 2, maxWidth: 720 }}>
        Download print-ready leaflets pre-filled with your franchise contact details. Each leaflet is generated on the fly so the phone number always matches the franchise you currently have selected.
      </Typography>

      <LeafletDownloads />
    </>
  );
}
